import { constants } from "../../../constants";

export default class SoundOff {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    SYN_handler(payload) {
        if (payload.data && payload.data.level && payload.data.level === 0) {
            this.gb.emitters.emit.web.soundOff();
        } else {
            this.gb.emitters.emit.web.soundOn();
        }
    }

    _default() {
        this.gb.emitters.emit.web.soundOff();
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.F1X2:
                event["audio-disable"] = this._default;
                break;
            case constants.EDICT:
                event["audioDisabled"] = this._default;
                break;
            case constants.GSPOKER:
           // case constants.GSBINGO:
                event["soundOff"] = this._default;
                break;
            case constants.STAKELOGIC2:
                event["SOUND_MUTE"] = this._default;
                break;
            case constants.SYN:
                event["g2p.setVolume"] = this.SYN_handler;
                break;
            case constants.ISOFT:
                event["SOUNDS_MUTED"] = this._default;
                break;  
            default:
                event["soundOff"] = this._default;
        }

        return event;
    }
}
